import {SendGiftStatusesE} from '@/features/gift/confirm-send-gift-modal/store/createConfirmSendGiftModalSlice'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {donateToGoal} from '../services/goal.http'
import {QUERY_KEYS} from './keys'
import {GoalV3} from '@/features/chat/chat.model'

export const useDonateGoalV3 = (onSuccess?: (status: SendGiftStatusesE) => void) => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: donateToGoal,
        onSuccess: goal => {
            queryClient.setQueriesData({queryKey: [QUERY_KEYS.selectedGoal, goal.id.toString()]}, goal)
            queryClient.setQueriesData(
                {queryKey: [QUERY_KEYS.hostGoals, goal.rookie.id]},
                (oldData: GoalV3[] | undefined) => {
                    if (!oldData) return oldData
                    return oldData.map(oldGoal => (goal.id === oldGoal.id ? goal : oldGoal))
                }
            )
            onSuccess?.(SendGiftStatusesE.Success)
        }
    })
}
